import SgVhumanVue2 from '../src/components/human/index.vue'
export {SgVhumanVue2}
const components =[SgVhumanVue2]
const Vue3ChatUi={
  install(App){
  components.forEach((component)=>{
    App.component(component.name,component)
  })
  }
}
export default Vue3ChatUi
